import React from "react";
import { PackageCheck } from "lucide-react";
import { useToastAlert } from "../../app/ToastAlert/ToastAlertProvider";
import { Box, Link, Typography } from "@mui/material";

export const useWebSpaChangesNotification = () => {
  const { showToastAlert, closeToastAlert } = useToastAlert();
  const notify = () => {
    return showToastAlert("info", {
      icon: () => <PackageCheck size={20} />,
      autoClose: false,
      message: (
        <Box>
          <Typography>
            New changes just shipped to the app!{" "}
            <Link
              color="inherit"
              component="span"
              onClick={() => window.location.reload()}
              sx={{ cursor: "pointer", textDecoration: "underline" }}
            >
              Reload to apply
            </Link>
          </Typography>
        </Box>
      ),
    });
  };
  return { notify, closeToastAlert };
};
